export default "__VITE_ASSET__DdL2zY5u__"